import {ModalFormFieldTypes} from 'components/formItems/FormGroup/FormGroup';

const fields: ModalFormFieldTypes[] = [
	{
		type: 'title',
		label: 'Հարցում'
	},
	{
		name: 'admissionPreparationIDs',
		type: 'select',
		dictionaryApiPath: 'candidateAdmissionPreparation',
		label: 'Ինչպե՞ս եք նախապատրաստվել ընդունելությանը',
		selectProps: {
			placeholder: 'Ինչպե՞ս եք նախապատրաստվել ընդունելությանը',
			mode: 'multiple'
		},
		colProps: {
			xs: 24,
			lg: 12
		}
	},
	{
		name: 'admissionPreparationSubjectIDs',
		type: 'select',
		dictionaryApiPath: 'candidateAdmissionSubjects',
		depFieldKey: 'admissionPreparationIDs',
		depValue: 4,
		label: 'Նշեք առարկաները',
		selectProps: {
			placeholder: 'Նշեք առարկաները',
			mode: 'multiple'
		},
		colProps: {
			xs: 24,
			lg: 12
		}
	},
	{
		name: 'universityInfoIDs',
		type: 'select',
		dictionaryApiPath: 'candidateUniversityInfo',
		label: 'Ինչպե՞ս եք առաջին անգամ իմացել ՀՖՀՀ-ի մասին',
		selectProps: {
			placeholder: 'Ինչպե՞ս եք առաջին անգամ իմացել ՀՖՀՀ-ի մասին',
			mode: 'multiple'
		},
		colProps: {
			xs: 24,
			lg: 12
		}
	},
	{
		name: 'universityInfoOther',
		type: 'text',
		depFieldKey: 'universityInfoIDs',
		depValue: 1,
		label: 'Ո՞րտեղից եք տեղեկություններ ձեռք բերել համալսարանի մասին (այլ)',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Ո՞րտեղից եք տեղեկություններ ձեռք բերել համալսարանի մասին (այլ)'
		},
		colProps: {
			xs: 24,
			lg: 12
		}
	},
	{
		name: 'openDoorsParticipation',
		type: 'select',
		label: 'Երբևէ մասնակցե՞լ եք Ֆրանսիական համալսարանի բաց դռների օրվան:',
		selectProps: {
			defaultValue: 0,
			options: [
				{label: 'Ոչ', value: 0},
				{label: 'Այո', value: 1}
			]
		},
		isRequired: true,
		colProps: {
			xs: 24,
			lg: 12
		}
	},
	{
		name: 'universityExpectationsText',
		label: 'Ըստ ձեզ՝ որո՞նք են այն 3 համալսարանները, որոնք լավագույնս համապատասխանում են ձեր սպասելիքներին:',
		type: 'text',
		isRequired: true,
		colProps: {
			xs: 24,
			lg: 12
		}
	},
	{
		type: 'divider'
	},
	{
		type: 'title',
		label: 'Ո՞րն է ՀՖՀՀ դիմելու ձեր հիմնական դրդապատճառը.'
	},
	{
		name: 'universityExpectations',
		label: 'Ավելացնել ուսումնական հաստատություն',
		type: 'formGroup',
		disableDynamicActions: true,
		disableDivider: true,
		inputs: [
			{
				name: 'universityExpectationsID',
				label: 'ID',
				type: 'text',
				colProps: {
					xs: 0
				}
			},
			{
				name: 'ratingID',
				label: 'Աշխատել ընտրած մասնագիտությամբ',
				type: 'radio',
				radioProps: {
					radioFields: [
						{
							label: 1,
							value: 1
						},
						{
							label: 2,
							value: 2
						},
						{
							label: 3,
							value: 3
						},
						{
							label: 4,
							value: 4
						},
						{
							label: 5,
							value: 5
						}
					]
				},
				colProps: {
					xs: 24
				}
			}
		],
		colProps: {
			sm: 24,
			xl: 12,
			xxl: 8
		}
	},
	{
		name: 'universityExpectationsOther',
		type: 'text',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Այլ'
		},
		isRequired: false
	}
];

export default fields;
